module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am198-71943ec3b159fac3a70fb90fc6636309.jpg";